import moment from "moment";
import http from "../http";

const apiUrl = `${process.env.REACT_APP_API_URL}`;

export function getVendors() {
  return http.get(`${apiUrl}vendors`);
}

export function getVendorMinimalList() {
  return http.get(`${apiUrl}vendors/minimal-data`);
}

export function getSingleVendor(id) {
  return http.get(`${apiUrl}vendors/${id}`);
}

export function saveVendor(data) {
  if (data.id) return http.put(`${apiUrl}vendors/${data.id}`, data);
  return http.post(`${apiUrl}vendors`, data);
}

export function deleteVendor(id) {
  return http.delete(`${apiUrl}vendors/${id}`);
}

export function getVendorLedgerData(
  id,
  limit,
  pageNumber,
  fromDate,
  toDate,
  searchString
) {
  let queryParams = `vendorId=${id}&limit=${limit}&page=${pageNumber}`;

  if (fromDate) {
    queryParams += `&fromDate=${moment(fromDate).format("YYYY-MM-DD")}`;
  }
  if (toDate) {
    queryParams += `&toDate=${moment(toDate).format("YYYY-MM-DD")}`;
  }

  if (searchString) {
    queryParams += `&searchString=${encodeURIComponent(searchString)}`;
  }

  return http.get(
    `${apiUrl}vendor-account-ledgers/findByVendorId?${queryParams}`
  );
}

export function getVendorALlLedgerData(id) {
  let queryParams = `vendorId=${id}`;

  return http.get(
    `${apiUrl}vendor-account-ledgers/findByVendorId?${queryParams}`
  );
}

export function getVendorAccountLedgerById(id) {
  return http.get(`${apiUrl}vendor-account-ledgers/${id}`);
}

export function updateVendorLedgerBalance(id, data) {
  return http.patch(
    `${apiUrl}vendor-balance/update-ledger-balance/${id}`,
    data
  );
}

export function getVendorBookingQue(
  id,
  limit,
  pageNumber,
  status,
  filters = {}
) {
  const queryParams = new URLSearchParams({
    page: pageNumber,
    limit: limit,
    vendorId: id,
    bookingStatus: status,
  });

  // Append only valid filter values to the query
  Object.keys(filters).forEach((key) => {
    if (filters[key]) {
      queryParams.append(key, filters[key]);
    }
  });

  return http.get(
    `${apiUrl}air-bookings/findByVendorId?${queryParams.toString()}`
  );
}

export function getVendorBookData(
  id,
  limit,
  pageNumber,
  status,
  bookingStatus
) {
  return http.get(
    `${apiUrl}air-refund-request/findByVendorId?page=${pageNumber}&limit=${limit}&type=${bookingStatus}&vendorId=${id}&status=${status}`
  );
}

export function getVendorReissueData(id, limit, pageNumber, status) {
  return http.get(
    `${apiUrl}air-reissue-request/findByVendorId?page=${pageNumber}&limit=${limit}&vendorId=${id}&status=${status}`
  );
}

export function getVendorSsrData(id, limit, pageNumber, status) {
  return http.get(
    `${apiUrl}air-ssr-request/findByVendorId?page=${pageNumber}&limit=${limit}&vendorId=${id}&status=${status}`
  );
}

export function reconcileVendorBalance(vendorId, data) {
  return http.patch(`${apiUrl}vendor-balance/reconciliation/${vendorId}`, data);
}

export function updateVendorAccountLedger(id, data) {
  return http.patch(`${apiUrl}vendor-account-ledgers/${id}`, data);
}

export function deleteVendorAccountLedger(id) {
  return http.delete(`${apiUrl}vendor-account-ledgers/${id}`);
}
